import React from 'react';

export default function Brand({ light = false }) {
  return (
    <a href="/" className={`flex items-center gap-2.5 select-none ${light ? 'text-paper' : 'text-ink'}`}>
      <span className="font-display text-[1.7rem] leading-none tracking-[0.16em] font-semibold">FIT</span>
      <span className="block h-6 w-[3px] bg-ember -skew-x-[18deg]" aria-hidden="true" />
      <span className="font-display text-[1.7rem] leading-none tracking-[0.08em] font-semibold">GAINERS</span>
    </a>
  );
}
